<script>
  let { width, height, label, icon, class: className } = $props();
</script>

<svg class={className} {width} {height} aria-label={label}>
  <use href="/assets/images/svg/spritemap#icon-{icon}"></use>
</svg>
